import React, { createContext, useContext, useState, useEffect } from 'react';
import { api } from '@/lib/api';

const SectionsContext = createContext({});

export const SectionsProvider = ({ children }) => {
  const [sections, setSections] = useState(null);

  useEffect(() => {
    loadSections();
  }, []);

  const loadSections = async () => {
    try {
      const res = await api.getSections();
      setSections(res.data);
    } catch {
      // Fallback: all visible
      setSections(null);
    }
  };

  const isSectionVisible = (key) => {
    if (!sections) return true;
    return sections[key]?.visible !== false;
  };

  const toggleSection = async (key, visible) => {
    try {
      await api.toggleSection(key, visible);
      setSections(prev => ({
        ...prev,
        [key]: { ...prev[key], visible },
      }));
    } catch (error) {
      console.error('Error toggling section:', error);
      throw error;
    }
  };

  return (
    <SectionsContext.Provider value={{ sections, isSectionVisible, toggleSection, reload: loadSections }}>
      {children}
    </SectionsContext.Provider>
  );
};

export const useSections = () => useContext(SectionsContext);
